import Image from 'next/image';
import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';

type Props = {
  src: string;
  alt: string;
  placeholder: string;
};

const ImagePreview = ({ src, alt, placeholder }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Image
        className="object-cover rounded-full shadow-lg cursor-pointer"
        src={src && src != '' ? src : placeholder}
        alt={alt}
        width={250}
        height={250}
        onClick={() => setIsOpen(true)}
      />
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setIsOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>
          <div className="fixed overflow-y-auto inset-4">
            <div className="flex items-center justify-center min-h-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-md align-middle shadow-lg transition-all text-[0px]">
                  <Image
                    src={src && src != '' ? src : placeholder}
                    alt={alt}
                    width={448}
                    height={448}
                  />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ImagePreview;
